import { Locale } from '@wyz/types';
import {
  polyfillDatetimeFormat,
  polyfillDisplayNames,
  polyfillNumberFormat,
  polyfillRelativetimeformat,
} from '@wyz/utils';
import { useNavigate } from 'react-router';
import { useManageUsers } from '~/common/api';
import { useApplicationContext } from '~/common/context';
import { log } from '~/common/helpers';

const loadLocaleApis = async (newLocale: Locale) => {
  await polyfillDatetimeFormat(newLocale);
  await polyfillRelativetimeformat(newLocale);
  await polyfillDisplayNames(newLocale);
  await polyfillNumberFormat(newLocale);
};

export const useManageLocale = () => {
  const applicationContext = useApplicationContext();
  const navigate = useNavigate();
  const manageUsers = useManageUsers({
    updateLocale: { enabled: true },
  });

  const updateLocale = (locale: string) => {
    try {
      void loadLocaleApis(locale);
      // eslint-disable-next-line no-empty
    } catch {}
    manageUsers.updateLocale.mutate(
      { id: String(applicationContext.auth.userId), locale },
      {
        onSuccess: () => {
          applicationContext.auth
            .signinSilent()
            .then(() => {
              window.location.reload();
            })
            .catch((error: Error) => {
              log(error);
              void navigate('/500');
            });
        },
      },
    );
  };

  return { updateLocale };
};
